var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      staticClass:
        "border-b border-dashed border-gray-300 pt-2 pb-1 hover:shadow-none w-full customCardConatiner",
    },
    [
      _c("div", { staticClass: "w-full" }, [
        _c("div", { staticClass: "flex flex-row w-full" }, [
          _c(
            "div",
            { staticClass: "mb-2 w-40" },
            [
              _c("CardBodySingleChip", {
                attrs: {
                  withAvatar: "",
                  customContainerClass: "h-auto",
                  newAvatarColor: "text-white removeMargin",
                  adjustPadding: "customgap",
                  background: _vm.bgStyle(_vm.review),
                  labelStyle:
                    "text-primary-black leading-3 text-sm font-normal w-max-content",
                  chipDetails: {
                    id: _vm.contractorId,
                    name: _vm.reviewerName,
                    routeParams: _vm.reviewerRouteParams,
                  },
                },
              }),
              _c(
                "p",
                {
                  staticClass:
                    "text-gray-400 font-outfit text-sm font-normal leading-5 adjustWidth",
                },
                [_vm._v(" " + _vm._s(_vm.reviewDate) + " ")]
              ),
              _vm._t("default"),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "w-full ml-2" },
            [
              _c("RatingStars", {
                staticClass: "-ml-0.5 mb-1 ml-auto justify-end",
                attrs: { value: _vm.score, starSize: 20, readOnly: "" },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass:
              "text-primary-black text-sm -mt-2 font-light ml-8 leading-6",
          },
          [_vm._v(" " + _vm._s(_vm.review) + " ")]
        ),
      ]),
      _vm._t("taskDeatils"),
      _vm.dialog
        ? _c("ReviewModal", {
            attrs: {
              review: _vm.review,
              score: _vm.score,
              ratingId: _vm.ratingId,
              contractorId: _vm.contractorId,
              currentUserId: _vm.currentUserId,
            },
            on: { close: _vm.toggleReviewModal, editted: _vm.handleEditted },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }